import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n-lite';

export default class NoDiscussionMessages extends Component {
  render() {
    return <div className="discussion-posts-empty">{I18n.t('discussions.common.noPostsYet')}</div>;
  }
}
